const getSelectedTicketPrice = ({ selectedTicket, quantity }: any) => {
  const price = selectedTicket
    ? selectedTicket.groupAttendeeNumber &&
      selectedTicket.groupAttendeeNumber > 1 &&
      quantity >= selectedTicket.groupAttendeeNumber
      ? selectedTicket.groupPrice
      : selectedTicket.price
    : 0;

  return price;
};

export default getSelectedTicketPrice;
